import { render, staticRenderFns } from "./codePage.vue?vue&type=template&id=1d2b959a&scoped=true&"
import script from "./codePage.vue?vue&type=script&lang=js&"
export * from "./codePage.vue?vue&type=script&lang=js&"
import style0 from "./codePage.vue?vue&type=style&index=0&id=1d2b959a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2b959a",
  null
  
)

export default component.exports